angular.module('core').filter('humanDate', ['$locale', 'moment', 'translateFilter',
    function($locale, $moment, translateFilter) {
        return function(timestamp) {
          var lastDay = translateFilter('shared.momentFormats.yesterdayWithDate', {defaultValue: '[Yesterday] LL'});
          var sameDay = translateFilter('shared.momentFormats.todayWithDate', {defaultValue: '[Today] LL'});
          var nextDay = translateFilter('shared.momentFormats.tomorrowWithDate', {defaultValue: '[Tomorrow] LL'});
          var nextWeek = translateFilter('shared.momentFormats.nextWeekAt', {defaultValue: 'dddd [at] LT'});

          return $moment(timestamp).locale($locale.id).calendar(null, {
            lastDay : lastDay,
            sameDay : sameDay,
            nextDay : nextDay,
            lastWeek : 'dddd LL',
            nextWeek : nextWeek,
            sameElse : 'dddd LL'
          });
        };
    }
]);
